import { jobs } from "./routes";
import IMask from "imask";
import BotCheckerForm from "./bot-checker-form";

export class Jobs {
    route = jobs;

    constructor() {
        this.botCheckerForm = new BotCheckerForm();

        this.vacancies = document.querySelector('.vacancies');

        if (this.vacancies) {
            this.init();
        }
    }

    init() {
        const route = window.location.pathname;
        if (!route.includes(`/${this.route}`)) {
            return;
        }
        let pathname = window.location.pathname.split('/');
        pathname = pathname.filter(v => v.length > 0);
        const jobId = parseInt(pathname.pop());
        const t = setInterval(() => {
            if (document.readyState === 'loading') {
                if (!isNaN(jobId)) {
                    const activeCard = document.querySelector('.job-card.active');
                    const offset = activeCard.getBoundingClientRect().top + window.scrollY;
                    document.getElementById('vacancy-id').value = activeCard.dataset.id;
                    window.scroll({
                        top: offset,
                        left: 0,
                    });
                }
                clearInterval(t);
            }
        }, 100);

        this.initListeners();
    }

    initListeners() {
        const maskName = {
            mask: function (value) {
                return /^[А-яA-Za-z\s\.\-\(\)]*$/.test(value);
            },
            lazy: false
        }
        const nameInput = document.querySelector('.js-input-job-name');
        if (nameInput) {
            // this.maskReadyName = new IMask(nameInput, maskName);
        }

        const maskEmail = {
            mask: function (value) {
                if (/^[a-z0-9_\.-]+$/.test(value))
                    return true;
                if (/^[a-z0-9_\.-]+@$/.test(value))
                    return true;
                if (/^[a-z0-9_\.-]+@[a-z0-9-]+$/.test(value))
                    return true;
                if (/^[a-z0-9_\.-]+@[a-z0-9-]+\.$/.test(value))
                    return true;
                if (/^[a-z0-9_\.-]+@[a-z0-9-]+\.[a-z]{1,4}$/.test(value))
                    return true;
                if (/^[a-z0-9_\.-]+@[a-z0-9-]+\.[a-z]{1,4}\.$/.test(value))
                    return true;
                if (/^[a-z0-9_\.-]+@[a-z0-9-]+\.[a-z]{1,4}\.[a-z]{1,4}$/.test(value))
                    return true;
                return false;
            },
            lazy: false
        }
        const emailInput = document.querySelector('.js-input-email');
        if (emailInput) {
            this.maskReadyEmail = new IMask(emailInput, maskEmail);
        }

        const btn = document.querySelector('.js-send-form-job');
        if (btn) {
            btn.addEventListener('click', (event) => {
                event.preventDefault();
                this.sendForm();
            });
        }

        this.formMsgWrapper = document.querySelector('.js-job-form-message-wrapper');
        this.formMsgWrapper.style.display = "none";
        this.formMsgText = document.querySelector('.js-job-form-message-text');

        document.querySelectorAll('.jobs .vacancies .job')?.forEach((el) => {
            el.addEventListener('click', (e) => {
                if (e.currentTarget.classList.contains('js-job-external-link')) {
                    return;
                }
                e.preventDefault();
                this.toggleJobDesktop(e.currentTarget);
            })
        })

        this.fileInputField = document.querySelector('.jobs .job-form #resume');
        this.fileLabel = document.querySelector('.job-form .file-name');
        this.fileInputField.addEventListener('change', (e) => {
            let files = this.fileInputField.files;
            if (!files.length) {
                this.fileLabel.textContent = 'Файл не выбран';
            } else {
                this.fileLabel.textContent = files[0].name;
            }
        });

        document.addEventListener('click', (e) => {
            if (e.target.matches('.jobs .start-career .trigger')) {
                e.preventDefault();
                e.target.classList.toggle('active');
                this.showHideHelp(e.target);
            }
            if (e.target.matches('.jobs .start-career .hide')) {
                document.querySelector('.jobs .start-career .trigger').classList.remove('active');
                this.showHideHelp(e.target)
            }
        });

        document.querySelector('#job-form')?.addEventListener('submit', () => {
            if (typeof ym !== 'undefined') {
                ym(46310949,'reachGoal','vakansiya');
            }
            if (typeof _tmr !== 'undefined') {
                _tmr.push({ type: 'reachGoal', id: 3332781, goal: 'vakansiya'});
            }
        })
    }

    sendForm() {
        this.formMsgWrapper.style.display = "none";
        this.formMsgWrapper.classList.remove('alert-danger');
        this.formMsgWrapper.classList.remove('alert-success');

        this.botCheckerForm.setCookie(
            "cl-time-on-page",
            this.botCheckerForm.getTimeFromStart(),
            1
        );
        let jobNameField = document.querySelector('.job-card.active .title-wrapper h2');
        let jobName = jobNameField === null ? 'Хочу у вас работать' : jobNameField.innerText.trim();
        let jobPlace = document.querySelector('[data-js-selected-city]').innerText.trim();
        let vacancyId = document.getElementById('vacancy-id').value;

        let data = new FormData();
        data.append('name', document.querySelector('#name').value);
        data.append('vacancy-id', vacancyId);
        data.append('job-place', jobPlace);
        data.append('email', document.querySelector('#email').value);
        data.append('phone', document.querySelector('#phone').value);
        data.append('fax', document.querySelector('.js-input-fax-job').value);
        data.append('reCaptchaToken', this.botCheckerForm.getGRecaptchaToken());
        const files = document.querySelector('#resume').files;
        if (files.length) {
            data.append('resume', files[0]);
        }

        const csrfToken = document.querySelector("meta[name='csrf-token']").content;
        const actionInput = document.querySelector('.js-input-action');

        fetch(
            actionInput.value,
            {
                method: 'post',
                headers: {
                    "X-Requested-With": "XMLHttpRequest",
                    "X-CSRF-Token": csrfToken
                },
                credentials: "same-origin",
                body: data
        }).then(result => {
            if (result.ok) {
                return result.json();
            } else {
                throw new Error('Something went wrong');
            }
        }).then((responseJson) => {
            this.formMsgWrapper.style.display = "flex";
            this.formMsgText.innerHTML = responseJson.text;
            if (responseJson.status === "ok") {
                this.formMsgWrapper.classList.add('alert-success');
            } else {
                this.formMsgWrapper.classList.add('alert-danger');
            }
        }).catch((error) => {
            this.formMsgWrapper.style.display = "flex"
            this.formMsgWrapper.classList.add('alert-danger');
            this.formMsgText.innerHTML = "Ошибка отправки! Повторите попытку позже или позвоните нам!"
        });
    }

    showHideHelp(el) {
        let startCareer = el.closest('.start-career');
        let hidden = startCareer.querySelector('.hidden');
        if (hidden) {
            hidden.style.display = hidden.style.display === 'none' ? 'block' : 'none';
        }
        document.querySelectorAll('.jobs .job-card').forEach(card => card.classList.remove('active'));
        document.querySelector('.jobs .job-form').classList.add('is-hidden');

        document.querySelector('.start-career')?.scrollIntoView({
            behavior: 'smooth'
        });
    }

    toggleJobDesktop(element) {
        const id = element.dataset.id;
        document.getElementById('vacancy-id').value = id;

        let card = this.vacancies.querySelector(`.job-card[data-id="${id}"]`)

        this.vacancies.querySelectorAll('.job-card')?.forEach((el) => {
            el.classList.remove('active');
        });
        this.vacancies.querySelector(`.job-card[data-id="${id}"]`)?.classList.add('active');

        this.vacancies.querySelectorAll('.job')?.forEach((el) => {
            el.classList.remove('active');
        });

        document.querySelector('.job-form__title').innerText = 'Откликнуться на вакансию';
        element.classList.add('active');

        let pathname = window.location.pathname.split('/');
        pathname = pathname.filter(v => v.length > 0)
        let city = pathname[0] || 'ptz';

        let refresh = window.location.origin + `/${city}/${this.route}/${id}/`;
        window.history.pushState({ path: refresh }, '', refresh);

        let vacancyName = element.querySelector('.text').innerText.trim();
        let lastBreadcrumb = document.querySelector('.js-breadcrumbs-item-last');
        if (lastBreadcrumb) {
            if (pathname[2] !== undefined) {
                lastBreadcrumb.textContent = vacancyName;
            } else {
                this.formatNewJobBreadcrumb(lastBreadcrumb, vacancyName);
            }
        }

        card.scrollIntoView({
            behavior: 'smooth'
        });
    }

    formatNewJobBreadcrumb(lastBreadcrumb, name) {
        const container = lastBreadcrumb.parentElement.parentElement;
        lastBreadcrumb.textContent = name;

        let firstBreadcrumbItem = container.querySelectorAll('li')[0];
        const newBreadcrumbItem = firstBreadcrumbItem.cloneNode(true);
        container.insertBefore(newBreadcrumbItem, lastBreadcrumb.parentElement);
        const newBreadcrumbBtn = newBreadcrumbItem.querySelector('.js-breadcrumb-btn');
        newBreadcrumbBtn.href = '/job/';
        const newBreadcrumbSpan = newBreadcrumbBtn.querySelector('.js-breadcrumb-btn-text');
        newBreadcrumbSpan.innerHTML = 'Вакансии';
        const newBreadcrumbMeta = newBreadcrumbItem.querySelector('.js-breadcrumb-meta');
        newBreadcrumbMeta.content = 2;
    }
}


